<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>點餐記錄/取餐</f7-nav-title>
    </f7-navbar>
    <f7-list accordion>
      <f7-list-item
        v-for="(order, index) in orderList"
        :key="`history-order-list-${index}`"
        accordion-item
        :accordion-item-opened="order.publicId === openOrderId"
        style="background-color: #F8F8F8;"
        :style="{ color: order.deliveredAt ? '#000000' : order.doneAt ? '#FF0000' : '#AAAAAA' }">
        <div slot="before-title">
          {{ order.doneAt && !order.deliveredAt ? '[請至櫃檯取餐] ' : '' }}
          [{{ moment.tz(order.updatedAt, 'utc').tz('Asia/Taipei').format('MM/DD') }}]
          {{ order.nickname }}
        </div>
        <div slot="after-title">
          {{ moment.tz(order.updatedAt, 'utc').tz('Asia/Taipei').format('HH:mm') }}
        </div>
        <f7-accordion-content id="order-content">
          <f7-block style="margin: 30px auto 0px; color: red; text-align: center;">
            <div v-if="order.refundedAt">此訂單已退款</div>
            <div v-else-if="(order.diningPreference === diningPreferenceType.forHere || order.diningPreference === diningPreferenceType.takeAway) && !order.paidAt">
              請憑此 QR code 至櫃台付款
            </div>
            <div v-else-if="order.diningPreference === diningPreferenceType.preOrder && !order.paidAt">請在取餐前憑此 QR code 至櫃台付款</div>
            <div style="font-size: 22px;" :style="{ 'font-weight': 'bold', color: order.deliveredAt ? '#000000' : '#FF0000' }">取餐代號: {{ order.nickname }}</div>
          </f7-block>
          <f7-block style="text-align: center; width: 100%; margin-bottom: 10px;">
            <div>
              <span>{{ $t(`diningPreferenceType.${order.diningPreference}`) }}</span>
              <div v-if="order.diningPreference === diningPreferenceType.forHere">桌號: {{ order.tableNumber }}</div>
              <div v-else-if="order.diningPreference === diningPreferenceType.preOrder">取餐時間: {{ order.pickupTime | moment("MM/DD HH:mm") }}</div>
            </div>
            <div v-if="order.taxId">統一編號: {{ order.taxId }}</div>
            <div v-if="order.invoiceTitle">收據抬頭: {{ order.invoiceTitle }}</div>
          </f7-block>
          <qr-code :text="order.publicId" :size="qrCodeWidth" level="H" />
          <f7-block style="width: 100%; padding: 30px 40px; color: #000000">
            <order-details :order="order" :menu="menus[order.menuVariation] ? menus[order.menuVariation][order.menuVersion] : null" />
          </f7-block>

          <f7-segmented v-if="payFirst && !order.paidAt" style="width: 90%; max-width: 300px; margin: 0px 0px 30px;">
            <f7-button raised fill style="background-color: #DD3333; margin: 0px 5px;" @click="deleteOrderOnClick(order.publicId)">取消訂單</f7-button>
            <f7-button raised fill style="background-color: #365899; margin: 0px 5px;" @click="editOrder(order)">修改訂單</f7-button>
          </f7-segmented>
          <f7-segmented v-else-if="order.paymentMethod === paymentMethodType.linePayOnline && !order.paidAt" style="width: 90%; max-width: 300px; margin: 0px 0px 30px;">
            <f7-button raised fill style="background-color: #4CAF50; margin: 0px 5px;" @click="sendLinePayInfo(order.publicId)">LINE Pay 付款</f7-button>
          </f7-segmented>
          <div style="color: #888888;">訂單狀態: {{ order | toStatusString }}</div>
          <div v-if="order.paymentMethod" style="color: #888888;">付款方式: {{ $t(`paymentMethodType.${order.paymentMethod}`) }}</div>
          <div v-if="order.useReceipt && order.useCashier && order.receiptCarrier" style="color: #888888;">發票載具: {{ $t(`receiptCarrierType.${order.receiptCarrier}`) }}</div>
          <div v-if="order.receiptCarrier === receiptCarrierType.barcode || order.receiptCarrier === receiptCarrierType.cdc" style="color: #888888;">載具 ID: {{ order.receiptCarrierId }}</div>
          <div style="font-size: 12px; color: #888888; margin-bottom: 30px;">
            最後更新時間: {{ moment.tz(order.updatedAt, 'utc').tz('Asia/Taipei').format('YYYY/MM/DD HH:mm:ss') }}
          </div>
          <history-order-timeline :order="order" />
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import QrCode from '@/common/components/QrCode'
import OrderDetails from '../components/OrderDetails'
import HistoryOrderTimeline from '../components/HistoryOrderTimeline'
import moment from 'moment-timezone'
import { storeClient } from '@/service/apiClients'

export default {
  dependencies: ['orderStatusType', 'diningPreferenceType', 'receiptCarrierType', 'paymentMethodType'],
  data () {
    return {
      windowWidth: 0,
      time: null,
      openOrderId: null
    }
  },
  props: {
    storeIdPathParam: String
  },
  computed: {
    ...mapState(['menuUrl', 'menuVariation']),
    ...mapState('menuModule', ['menus']),
    ...mapState('orderModule', ['orderList']),
    ...mapGetters(['storeId', 'payFirst', 'fullStoreName']),
    moment () { return moment },
    qrCodeWidth () {
      // TODO 這邊還要經過實際測試才知道最大可以多大，目的是不要讓 qrcode 超過 scanner
      return Math.min(300, this.windowWidth * 0.5)
    }
  },
  filters: {
    toStatusString (order) {
      return order.deliveredAt ? '已取餐' : order.doneAt
        ? '已完成'
        : order.startPreparingAt ? '製作中' : '尚未開始製作'
    }
  },
  created () {
    this.setStore(this.storeIdPathParam).then(() => {
      this.getHistoryOrders()
    })
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      // Init
      this.getWindowWidth()
      this.getWindowHeight()

      this.openOrderId = this.getQueryString('id')
    })
  },
  methods: {
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    },
    getQueryString (name) {
      const url = window.location.href
      name = name.replace(/[[\]]/g, '\\$&')
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      const results = regex.exec(url)
      if (!results) {
        return null
      }
      if (!results[2]) {
        return ''
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    redirctToIndex () {
      this.$f7.dialog.confirm('是否回到菜單頁面?', '離開', () => {
        this.resetBucket({ itemBucket: 'cart' })
        this.$f7router.navigate(this.menuUrl, { reloadCurrent: true })
      })
    },
    async sendLinePayInfo (publicId) {
      const result = await storeClient.get(`/stores/${this.storeId}/orders/${publicId}/payment/${this.paymentMethod}/info`)
      window.replaceLocation(result.data.paymentUrl.web)
    },
    editOrder (order) {
      this.resetOrderParams()
      this.setOrderParams({
        nickname: order.nickname,
        publicId: order.publicId,
        diningPreference: order.diningPreference,
        tableNumber: order.tableNumber,
        pickupTime: order.pickupTime,
        phoneNumber: order.phoneNumber,
        paymentMethod: order.paymentMethod,
        receiptCarrier: order.receiptCarrier,
        receiptCarrierId: order.receiptCarrierId,
        taxId: order.taxId
      })
      this.resetBucket({ itemBucket: 'cart' })
      this.setCartItems(order.data.items)
      this.$f7router.back()
    },
    async deleteOrderOnClick (publicId) {
      try {
        await this.deleteOrder(publicId)
        this.$f7.dialog.alert('取消成功', this.fullStoreName)
      } catch (e) {
        this.$f7.dialog.alert('餐點取消只限取餐時間十分鐘前的未付款訂單', '取消失敗')
      }
      this.getHistoryOrders()
    },
    ...mapActions(['deleteOrder', 'setStore', 'resetOrderParams', 'setOrderParams']),
    ...mapActions('itemModule', ['setCartItems', 'resetBucket']),
    ...mapActions('orderModule', ['getHistoryOrders'])
  },
  components: {
    QrCode,
    OrderDetails,
    HistoryOrderTimeline
  }
}
</script>

<style lang="scss" scoped>
#order-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction:column;
  background-color: #FFFFFF;
  box-shadow: inset 0px 3px 3px #AAAAAA, inset 0px -3px 3px #AAAAAA;
}
</style>
